
import { ModalController, NavParams, Platform } from '@ionic/angular';
import { Component, OnInit } from '@angular/core';
import { ContactPerson } from '../../../_interfaces/ContactPerson';
import { SaveService } from '../../../_provider/save.service';
import { HttpFunctionResult } from '../../../_interfaces/HttpFunctionResult';
import { CrmService } from '../../../_provider/crm.service';
import { HttpService } from '../../../_provider/http.service';
import { FeedbackService } from '../../../_provider/feedback.service';
import { VCard } from 'src/app/_interfaces/VCard';
import * as vCardParser from "vcard-parser"
import { GeneralService } from 'src/app/_provider/general.service';

@Component({
  selector: 'app-add-contact-person',
  templateUrl: './add-contact-person.page.html',
  styleUrls: ['./add-contact-person.page.scss']
})
export class AddContactPersonPage implements OnInit {

  public contactPerson: ContactPerson = {}
  public employeeCanSetOnlinePermission: boolean = false
  private addressId: number

  public onlineAccess: boolean = false

  constructor(
    private navParams: NavParams,
    private modalCtrl: ModalController,
    public crmSrv: CrmService,
    public platform: Platform,
    public generalSrv: GeneralService,
    private feedback: FeedbackService,
    private httpSrv: HttpService
  ) { }

  ngOnInit() {
    this.addressId = this.navParams.get("addressId") as number
    const contactPerson: ContactPerson = this.navParams.get("contactPerson") as ContactPerson
    this.employeeCanSetOnlinePermission = this.navParams.get("employeeCanSetOnlinePermission") as boolean
    if(contactPerson){
      this.contactPerson = contactPerson
      this.onlineAccess = contactPerson.onlinePermission
    }
  }

  public async save(){
    if(!this.contactPerson.firstName){
      await this.feedback.showError("Bitte geben Sie einen Vornamen ein.")
      return
    }

    if(this.onlineAccess && !this.contactPerson.email){
      await this.feedback.showError("Um den Onlinezugang zu aktivieren muss eine E-Mail-Adresse hinterlegt werden.")
      return
    }

    if(this.onlineAccess && !this.contactPerson.onlinePermission){
      if(!(await this.feedback.confirm("Sie haben den Online-Zugang aktiviert. Wenn Sie speichern wird der Kontaktperson eine E-Mail zugesendet, um das Passwort festzulegen. Möchten Sie fortfahren?", "Fortfahren", "Abbrechen"))) return
    }
    this.contactPerson.onlinePermission = this.onlineAccess
    await this.feedback.updateLoading("Speichern...")
    const saveSrv: SaveService.CRM = new SaveService.CRM(this.httpSrv);
    await this.feedback.hideKeyboardOnIOS()
    if(this.contactPerson.id != null){
      const result: HttpFunctionResult<ContactPerson> = await saveSrv.saveContactPerson(this.contactPerson, this.addressId)
      if(result.success) this.modalCtrl.dismiss(result.data)
    }else{
      const result: HttpFunctionResult<ContactPerson> = await saveSrv.addContactPerson(this.contactPerson, this.addressId)
      if(result.success) this.modalCtrl.dismiss(result.data)
    }
    await this.feedback.hideLoading()
  }

  public async closeModal(){
    await this.feedback.hideKeyboardOnIOS()
    await this.modalCtrl.dismiss()
  }

  public async openQrCode(){
    const vcardResponse: HttpFunctionResult<string> = await this.feedback.getQRCodeData()
    if(!vcardResponse.success) return
    const parsedData: VCard = vCardParser.parse(vcardResponse.data) as VCard
    try {
      this.contactPerson.salutation = this.getVcardValue(parsedData, "title") 
      this.contactPerson.firstName =  this.getVcardValueByArray(parsedData, "n", 1) 
      this.contactPerson.lastName = this.getVcardValueByArray(parsedData, "n", 0) 
      this.contactPerson.telefone = this.getVcardValue(parsedData, "tel") 
      this.contactPerson.mobile = this.getVcardValue(parsedData, "tel", 1) 
      this.contactPerson.email = this.getVcardValue(parsedData, "email") 
    } catch (error) {
      alert(error)
    }  
  }

  private getVcardValue(vcardResponse: VCard, name: string, position: number = 0): string{
    if( vcardResponse?.[name] == undefined) return ""
    return vcardResponse?.[name][position]?.value || ""
  }

  private getVcardValueByArray(vcardResponse: VCard, name: string, position: number = 0): string{
    if( vcardResponse?.[name] == undefined) return ""
    if( vcardResponse?.[name][0]?.value[position] == undefined) return ""
    return vcardResponse?.[name][0]?.value[position] || ""
  }

}
